module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0046.png.d2dd14a0.jpg";